
<script lang="ts">
  import { useAccordion } from '../use-accordion.svelte';
  import { AccordionProvider } from '../use-accordion-context';
  import type { AccordionProps } from '../accordion.types';

  const { children, ...props }: AccordionProps = $props();

  const accordion = useAccordion(props);
  AccordionProvider(accordion);

  export function setValue(value: string[]) {
    accordion.api.setValue(value);
  }

  export function getValue() {
    return accordion.api.value;
  }
</script>

<div {...accordion.api.getRootProps()}>
  {#if children}
    {@render children()}
  {/if}
</div>
